<template>
  <div ref="main">
    <slot :handlerDocClicked="handlerDocClicked"></slot>

    <div class="fixed inset-0 min-h-screen overflow-hidden z-30" ref="player" v-if="isOpen">
      <div class="bg-black bg-opacity-40 w-screen h-screen absolute z-10" @click="toggleOpen"></div>
      <div class="absolute z-50 inset-0 mx-auto flex items-center justify-center md:max-w-3xl" @click="handlerClicked">
        <document-embed
          :url="urlElement"
          :width="width"
          :height="height"
        />
      </div>

      <button class="flex absolute top-5 right-5 cursor-pointer bg-white bg-opacity-80 hover:bg-geb-gray-25 hover:bg-opacity-90 rounded-md group z-50" @click="toggleOpen" aria-label="Close">
        <i class="w-8 h-8 text-geb-dark-800 group-hover:text-geb-gray-700" v-icon:close-x></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DocumentViewer",
  data() {
    return {
      urlElement: null,
      width: 500,
      height: 500,
      isOpen: false,
      hasError: false,
      errorMessage: '',
      parentContainer: null
    };
  },
  methods: {
    handlerClicked(e){
      if (!e.target.classList.contains('iframe--document-embed')) this.toggleOpen();
    },
    toggleOpen() {
      if (this.isOpen) this.resetData();
      this.isOpen = !this.isOpen;
      document.getElementsByTagName('body')[0].classList.toggle('overflow-hidden');
    },
    resetData() {
      if (this.parentContainer) this.parentContainer.parentElement.classList.remove('z-auto');
      this.parentContainer = null;
      this.hasError = false;
      this.errorMessage = '';
      this.urlElement = null;
      this.width = 500;
      this.height = 500;
    },
    handlerDocClicked(url, w, h) {
      this.parentContainer = this.$refs.main.closest('.full-container');
      if (this.parentContainer) this.parentContainer.parentElement.classList.add('z-auto');
      if (w) this.width = w;
      if (h) this.height = h;

      this.urlElement = url;
      if (!url || url === '') {
        this.hasError = true;
        this.errorMessage = 'Se ha proporcionado una URL vacía o invalida.';
      }
      this.isOpen = true;
      document.getElementsByTagName('body')[0].classList.toggle('overflow-hidden');
    },
  },
  mounted () {
    window.addEventListener("keyup", (evt) => {
      if (this.isOpen && (evt.code.toLowerCase() === 'escape' || (evt.keyCode === 27))) this.toggleOpen();
    },false);
  },
};
</script>